/* eslint-disable */
<template>
  <v-card class="mx-auto" flat>
    <v-card-title>
      My Renewals
      <v-spacer />
      <v-btn
        v-if="batchedRenewals.length > 1"
        color="primary"
        @click="activateSelectBatchReceipt"
      >
        <v-icon class="mr-2">mdi-cash</v-icon>
        Pay all
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table :headers="headers" :items="renewals" dense>
        <!--eslint-disable-next-line -->
        <template v-slot:item.ID="{ index }">
          <span>{{ index + 1 }}</span>
        </template>
        <template v-slot:[`item.billedAmount`]="{ item }">
          <span>{{ item.billedAmount | currencyFormat }}</span>
        </template>
        <template v-slot:[`item.paidAmount`]="{ item }">
          <span>{{ item.paidAmount | currencyFormat }}</span>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <span class="text-capitalize">
            <v-icon
              size="15"
              :color="
                item.status === 'Active' ? 'primary' : 'deep-orange lighten-1'
              "
            >
              mdi-radiobox-marked
            </v-icon>
            {{ item.status }}
          </span>
        </template>
        <template v-slot:[`item.paid`]="{ item }">
          <span class="text-capitalize">
            <v-icon
              size="15"
              :color="item.paid ? 'primary' : 'deep-orange lighten-1'"
            >
              mdi-radiobox-marked
            </v-icon>
            {{ item.paid ? "Paid" : "Not Paid" }}
          </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="text-capitalize links"
                text
                v-bind="attrs"
                v-on="on"
                small
                ><v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-if="!item.paid"
                :to="{
                  name: 'RenewalProforma',
                  params: { code: item.serviceRequest },
                }"
              >
                <v-icon color="primary">payments</v-icon> Pay
              </v-list-item>

              <v-divider v-if="item.paid && item.recieptNo.length > 0" />
              <v-list-item
                v-if="item.paid && item.recieptNo.length > 0"
                :to="{
                  name: 'RenewalReceipt',
                  params: { code: item.recieptNo },
                }"
              >
                <v-icon color="primary">receipt</v-icon> View Receipt
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card-text>
    <BatchPaymentDialoge @setRenewalBatchPayment="payAll" />
    <InvoiceDialog />
  </v-card>
</template>

<script>
import { appUrl } from "../../dashboard/environment";
import { AuthService } from "@/packages/dashboard/modules/auth";
import BatchPaymentDialoge from "./BatchPaymentDialoge.vue";
import InvoiceDialog from "./InvoiceDialog.vue";

export default {
  name: "RenewalListComponent",
  props: { renewals: Array },
  components: { BatchPaymentDialoge, InvoiceDialog },
  data: function () {
    return {
      headers: [
        { text: "#S/N", sortable: true, value: "ID" },
        {
          text: "Programme",
          align: "start",
          sortable: false,
          value: "currentProgrammeCode",
        },
        { text: "Renewal Period", sortable: false, value: "renewalPeriod" },
        { text: "Billed Amount", sortable: false, value: "billedAmount" },
        { text: "Paid Amount", sortable: false, value: "paidAmount" },
        { text: "Due On", sortable: false, value: "dueDate" },
        { text: "Payment Status", value: "paid" },
        { text: "status", value: "status" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },

  computed: {
    profileId: function () {
      return this.renewals.length ? this.renewals[0].profileID : null;
    },
    hasPendingRenewals: function () {
      return this.renewals.filter((item) => !item.paid).length > 0;
    },
    batchedRenewals() {
      return this.$store.getters["Renewal/renewalGetters"]("batchRenewal");
    },
    user() {
      return AuthService.user;
    },
  },

  methods: {
    activateSelectBatchReceipt() {
      this.$store.commit("Renewal/MUTATE", {
        state: "openBatchReceiptsDialog",
        data: true,
      });
    },
    /**
     *
     * @param arg | OBJECT
     */
    payAll(arg) {
      const PhoneNo =
        this.user.profile.phoneNo.charAt(0) === "+"
          ? this.user.profile.phoneNo.slice(1)
          : this.user.profile.phoneNo.charAt(0) === "0"
            ? `254${this.user.profile.phoneNo.slice(1)}`
            : this.user.profile.phoneNo;
      const data = arg.payload;
      let payload = {
        payerID: data.profileID,
        serviceID: data.serviceCode,
        description: "Renewal Payment",
        accountNo: PhoneNo,
        email: this.user.profile.email,
        idNumber: this.user.profile.identificationDocumentNo,
        name: `${this.user.profile.firstName} ${this.user.profile.lastName}`,
        success_url: `${appUrl}${
          this.$router.resolve({ name: "RegistrationList" }).href
        }`,
        fail_url: window.location.href,
      };
      let confirmationMsg = "";
      if (arg.isBatch) {
        this.$checkout.constants.getPesaflowIframe = `${this.$checkout.constants.getPesaflowIframe}?isBatch=${arg.isBatch}`;
        confirmationMsg = data.map((item) => item.serviceRequest).join(" , ");
        payload = {
          ...payload,
          serviceID: data[0].serviceCode,
          payerID: data[0].profileID,
          batch: data.map((item) => ({
            amount: item.billedAmount,
            sourceDocumentNo: item.serviceRequest,
          })),
        };
      } else {
        confirmationMsg = data.serviceRequest;
        this.$checkout.constants.getPesaflowIframe = `${this.$checkout.constants.getPesaflowIframe}?isBatch=${arg.isBatch}`;
        payload = {
          ...payload,
          sourceDocumentNo: data.serviceRequest,
          amount: parseFloat(data.billedAmount).toString(),
        };
      }
      this.$confirm.show({
        title: "Renewal Payment",
        rejectLabel: "Pay Later",
        text: `Application Payment for Renewal No. ${confirmationMsg}`,
        onConfirm: () => {
          payload = btoa(JSON.stringify(payload));
          this.$checkout.pay(payload, arg.isBatch);
        },
        onCancel: () => {
          Event.$emit("ApiInfo", "Payment cancelled");
          this.$router.replace({ name: "RegistrationList" });
        },
      });
      this.$store.commit("Renewal/MUTATE", {
        state: "openBatchReceiptsDialog",
        data: false,
      });
    },
  },
};
</script>
